import styled from 'styled-components';
import { Body2, colors, spacing } from 'ui/theme';

export const StyledSuffix = styled(Body2)`
  color: ${colors.grey50};
`;

export const StyledDescription = styled(Body2)`
  color: ${colors.secondaryText};
`;

export const InputFieldWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: ${spacing.half};

  span {
    line-height: 2.5;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing.half};
`;
